(function () {

    'use strict';

    angular.module('app.staticpage', []);

})();


// WEBPACK FOOTER //
// ./app/staticpage/staticpage.module.js